export default ".subtitle {\n  font-weight: 200;\n}"